import { EntityModel } from '@/interfaces'
import {
  ALL_COLLECTIVE_DISCOUNTS_QUERY,
  CREATE_COLLECTIVE_DISCOUNT_MUTATION,
  DELETE_COLLECTIVE_DISCOUNT_MUTATION,
  FORCE_DELETE_COLLECTIVE_DISCOUNT_MUTATION,
  SINGLE_COLLECTIVE_DISCOUNT_QUERY,
  UPDATE_COLLECTIVE_DISCOUNT_MUTATION,
} from './graphql'
import ratioAgeGroupServiceEntity from '@/entities/ratioAgeGroupService/entity'
import travelPricingMandatorySettingsEntity from '@/entities/travelPricingMandatorySettings/entity'

const ratioCollectiveDiscountModel: EntityModel = {
  name: 'collectiveDiscount',
  namePlural: 'collectiveDiscounts',
  uniqueName: 'ratioCollectiveDiscount',
  uniqueNamePlural: 'ratioCollectiveDiscounts',
  path: 'travel/pricing/adaptors/ratio/collective_discount',
  baseUrl: '/travel/pricing/adaptors/ratio/collective_discounts',
  translationPrefix: 'entities:ratioCollectiveDiscount.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_COLLECTIVE_DISCOUNTS_QUERY,
    getSingle: SINGLE_COLLECTIVE_DISCOUNT_QUERY,
    create: CREATE_COLLECTIVE_DISCOUNT_MUTATION,
    update: UPDATE_COLLECTIVE_DISCOUNT_MUTATION,
    delete: DELETE_COLLECTIVE_DISCOUNT_MUTATION,
    forceDelete: FORCE_DELETE_COLLECTIVE_DISCOUNT_MUTATION,
  },
  attributes: {
    label: {
      name: 'label',
      label: 'entities:ratioCollectiveDiscount.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:ratioCollectiveDiscount.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [],
    },
    ageGroupServices: {
      name: 'ageGroupServices',
      label: 'entities:ratioCollectiveDiscount.attributes.ageGroupServices.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return ratioAgeGroupServiceEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    mandatorySettings: {
      name: 'mandatorySettings',
      label: 'entities:ratioCollectiveDiscount.attributes.mandatorySettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingMandatorySettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioCollectiveDiscountModel
